import React from "react";

import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";

import SweetAlert2 from "react-sweetalert2";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

import Header from "components/Headers/Header.js";

import Api from "shared/resources/Api";
import { healthUnits } from "shared/services/PlacesService";
import InputNumber from "react-input-just-numbers";

export default class UbvList extends React.Component {
  /* Dados Grid */
  columns = [
    {
      name: "Código",
      maxWidth: "50px",
      selector: "id",
      sortable: true,
    },
    {
      name: "Logradouro",
      selector: "logradouro",
      sortable: true,
    },
    {
      name: "Número",
      selector: "numero",
      sortable: true,
    },
    {
      name: "Bairro",
      selector: "Bairro",
      sortable: true,
      cell: (row) => (
        <div>
          {row.bairro !== undefined && row.bairro !== null
            ? row.bairro
            : "-"}
        </div>
      ),
    },
    {
      name: "Complemento",
      selector: "complemento",
      sortable: true,
    },
    {
      name: "Nome Paciente",
      selector: "nome_paciente",
      sortable: true,
      cell: (row) => <div>{row.nome_paciente ? row.nome_paciente : "-"}</div>,
    },
    {
      name: "Unidade Saúde",
      selector: "unidade_saude",
      sortable: true,
      cell: (row) => <div>{row.unidade_saude ? row.unidade_saude : "-"}</div>,
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
    },
    {
      name: "",
      center: true,
      cell: (row) => (
        <div>
          <Button
            type="button"
            className="btn-acao "
            title="Editar"
            onClick={() => {
              this.props.history.push("/admin/ubv-edit", {
                ubv: row,
              });
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="edit" />
          </Button>
          {localStorage.getItem("perm") !== "agente" && (
            <Button
              type="button"
              className="btn-acao "
              title="Remover"
              onClick={() => {
                this.handleDelete(row);
              }}
            >
              <FontAwesomeIcon icon={faTrashAlt} className="remove" />
            </Button>
          )}
        </div>
      ),
    },
  ];
  defaultComponentOptions = {
    rowsPerPageText: "Registros por Página:",
    rangeSeparatorText: "de",
    noRowsPerPage: false,
  };
  customStyles = {
    headCells: {
      style: {
        fontWeight: 700,
        fontSize: 15,
        color: "#000",
      },
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      response: "",
      nome: "",
      logradouro: "",
      tel: "",
      api: Api.baseURL,
      id: "",
      requesting: false,
      neighborhood: [],
      sectors: [],
      healthUnits: [],
      bairro: "",
      selectedUnit: "",
      selectedNeighborhood: null,
      status: "",
      tratamento: "",
      complemento: "",
      quarteirao: null,
      lado: "",
      numero: ""
    };
  }
  componentWillMount() {
    document.addEventListener("keydown", (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        this.handleSubmit(event);
      }
    });

    if (localStorage.getItem("gridubv")) {
 
      var obj = JSON.parse(localStorage.getItem("gridubv"));
      this.setState({
        response: obj,
      })
    }

    healthUnits().then((res) => {
      if (res) {
        this.setState({
          healthUnits: res,
        });
      }
    });
  }

  fetchSectors = async () => {
    const response = await fetch(Api.baseURL + "/setor", {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });
    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        sectors: body,
      });
    }

    return body;
  };

  fetchNeighborhood = async () => {
    const response = await fetch(Api.baseURL + "/bairro", {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });
    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        neighborhood: body,
      });
    }

    return body;
  };



  handleSubmit = (event) => {
   

    this.setState({ response: "", requesting: true });
    this.fetchUbv()
      .then((res) => this.setState({ response: res }, () => {
        // localStorage.setItem("gridubv", JSON.stringify(res));
      }))
      .catch((err) => {
        console.log(err);
        this.setState({
          swal: {
            show: true,
            title: "Atenção",
            text:
              "Não foram encontradas UBV's para os parâmetros informados.",
            type: "error",
          },
          requesting: false,
        });
      });


    event.preventDefault();
  };

  fetchUbv = async () => {
    let host = this.state.api + "/ubv?";

    let params = {
      id: this.state.id,
      logradouro: this.state.logradouro.trim(),
      bairro: this.state.bairro,
      quarteirao: this.state.quarteirao !== null && this.state.quarteirao !== undefined ? this.state.quarteirao : 0,
      lado: this.state.lado,
      cod_unidade_saude: this.state.selectedUnit,
      numero: this.state.numero,
      complemento: this.state.complemento,
      status: this.state.status
    };
    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");

    const response = await fetch(host + query, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();

    if (body.length > 0) {
      this.setState({
        agent: body,
        requesting: false,
      });
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text:
            "Não foram encontradas UBV's para os parâmetros informados.",
          type: "error",
        },
        requesting: false,
      });
    }
    return body;
  };
  handleDelete = (element) => {
    this.setState({
      swal: {
        show: true,
        title: "Atenção",
        text: "Deseja realizar a exclusão deste registro?",
        type: "error",
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: "Cancelar",
      },
      trieshop: element,
      isConfirmation: true,
    });
  };
  handleDeleteUbv(d) {
    this.callDel(d)
      .then()
      .catch((err) => console.log(err));
  }

  callDel = async (d) => {
    const response = await fetch(Api.baseURL + "/ubv/" + d.id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        swal: {
          show: true,
          title: "Tudo Certo",
          text: "UBV deletada com sucesso!",
          type: "success",
        },
        response: "",
        nome: "",
        logradouro: "",
        bairro: "",
        quarteirao: "",
        lado: "",
        selectedUnit: "",
        numero: "",
        complemento: "",
        id: "",
        status: ""
      });
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Erro ao deletar UBV.",
          type: "error",
        },
      });

      throw Error(body.message);
    }

    return body;
  };

  render() {
    return (
      <>
        <SweetAlert2
          {...this.state.swal}
          onConfirm={(result) => {
            this.setState({
              swal: {
                show: false,
              },
            });

            if (this.state.isConfirmation && !result.dismiss) {
              this.setState({
                isConfirmation: false,
              });
              this.handleDeleteUbv(this.state.trieshop);
            }
          }}
        />

        <Header />
        {/* Page content */}
        <Container className="mb-7 mt-5 " fluid>
          <Row className="mb-3">
            <Col className="order-xl-1">
              <Card className="bg-secondary shadow">
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      Consulta Bloqueio
                    </h6>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Código
                            </label>
                            <InputNumber
                              onlydigits
                              className="form-control"
                              id="input-id"
                              inputMode="numeric"
                              maxLength="12"
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 6);
                              }}
                              placeholder=""
                              value={this.state.id}
                              onChange={(e) =>
                                this.setState({ id: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="9">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-logradouro"
                            >
                              Logradouro
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-logradouro"
                              type="text"
                              required
                              maxLength="40"
                              value={this.state.logradouro}
                              onChange={(e) =>
                                this.setState({ logradouro: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        {/* <Col lg="3">
                          <FormGroup>
                            {this.state.sectors.length > 0 && (
                              <div>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-dtnascimento"
                                >
                                  Setor
                                </label>

                                <select
                                  value={this.state.selectedUnit}
                                  onChange={(e) =>
                                    this.setState({
                                      selectedUnit: e.target.value,
                                    })
                                  }
                                  className="form-control "
                                >
                                  <option defaultValue="" value="">
                                    {" "}
                                    Selecione...{" "}
                                  </option>
                                  {this.state.sectors.map((team) => (
                                    <option
                                      key={team.id}
                                      value={team.id}
                                      defaultValue={this.state.selectedUnit}
                                    >
                                      {team.nome}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                         */}
                      </Row>
                      <Row>
                        <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-numero"
                            >
                              Número
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-lado"
                              type="text"
                              maxLength="30"
                              value={this.state.numero}
                              onChange={(e) =>
                                this.setState({ numero: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-bairro"
                            >
                              Bairro
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-lado"
                              type="text"
                              maxLength="30"
                              value={this.state.bairro}
                              onChange={(e) =>
                                this.setState({ bairro: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>


                        <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-complemento"
                            >
                              Complemento
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-lado"
                              type="text"
                              maxLength="30"
                              value={this.state.complemento}
                              onChange={(e) =>
                                this.setState({ complemento: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-quarteirao"
                            >
                              Quarteirão
                            </label>

                            <InputNumber
                              onlydigits
                              className="form-control"
                              id="input-quarteirao"
                              inputMode="numeric"
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 4);
                              }}
                              placeholder=""
                              value={this.state.quarteirao}
                              onChange={(e) =>
                                this.setState({ quarteirao: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>{" "}
                        <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-logradouro"
                            >
                              Lado
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-lado"
                              type="text"
                              required
                              maxLength="4"
                              value={this.state.lado}
                              onChange={(e) =>
                                this.setState({ lado: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>{" "}
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            {this.state.healthUnits.length > 0 && (
                              <div>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-dtnascimento"
                                >
                                  Unidade de Saúde
                                </label>

                                <select
                                  value={this.state.selectedUnit}
                                  onChange={(e) =>
                                    this.setState({
                                      selectedUnit: e.target.value,
                                    })
                                  }
                                  className="form-control "
                                >
                                  <option defaultValue="" value="">
                                    {" "}
                                    Selecione...{" "}
                                  </option>
                                  {this.state.healthUnits.map((team) => (
                                    <option
                                      key={team.cod}
                                      value={team.cod}
                                      defaultValue={this.state.selectedUnit}
                                    >
                                      {team.nome}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Status
                            </label>

                            <select
                              value={this.state.status}
                              onChange={(e) =>
                                this.setState({ status: e.target.value })
                              }
                              className="form-control "
                              id="select-tipo"
                            >
                              <option defaultValue="" value="">
                                {" "}
                                Selecione...{" "}
                              </option>

                              <option value="ACIONAR_BLOQ">Acionar o Bloqueio</option>
                              <option value="BLOQ_FOCAL">Bloqueio Focal</option>
                              <option value="BLOQ_FOCAL_TERMO">Bloqueio Focal e Termonebulizador</option>
                              <option value="BLOQ_FOCAL_UBV_LEVE">Bloqueio Focal e UBV-Leve</option>
                              <option value="BLOQ_FOCAL_UBV_PESADO">Bloqueio Focal e UBV-Pesado</option>
                              <option value="BLOQ_TERMO">Bloqueio Termonebulizador</option>
                              <option value="BLOQ_UBV_LEVE">Bloqueio UBV-Leve</option>
                              <option value="BLOQ_UBV_LEVE_PESADO">Bloqueio UBV-Leve e Pesado</option>
                              <option value="BLOQ_UBV_LEVE_TERMO">Bloqueio UBV-Leve e Termonebulizador</option>
                              <option value="BLOQ_UBV_PESADO">Bloqueio UBV-Pesado</option>
                              <option value="CLIMA_INAD_BLOQ">Clima Inadequado para o Bloqueio</option>
                              <option value="END_INCOMPATIVEL">Endereço incompatível</option>
                              <option value="INVESTIGAR_END">Investigar o Endereço</option>
                              <option value="MORADOR_AUSENTE">Morador Ausente</option>
                              <option value="NOVO_DIAGNOSTICO">Novo Diagnóstico</option>
                            </select>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <div className="text-center">
                      <Row>
                        <Col className="order-xl-1" xl="12">
                          {" "}
                          <Button
                            className="mt-4 btn-zoo-alt"
                            color="primary"
                            type="button"
                            onClick={this.handleSubmit}
                          >
                            <b>Pesquisar</b>
                          </Button>
                          {localStorage.getItem("perm") !== "agente" && (
                            <Button
                              className="mt-4 btn-zoo"
                              color="primary"
                              type="button"
                              onClick={() => {
                                this.props.history.push("/admin/ubv-edit");
                              }}
                            >
                              <b>Cadastrar</b>
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.response && !this.state.requesting && (
            <DataTable
              noHeader={true}
              pagination={true}
              striped={true}
              columns={this.columns}
              responsive={true}
              highlightOnHover={true}
              data={this.state.response}
              paginationComponentOptions={this.defaultComponentOptions}
              paginationPerPage={5}
              paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
              customStyles={this.customStyles}
              progressPending={this.state.response === undefined}
              noDataComponent="Nenhum registro encontrado."
              paginationResetDefaultPage={this.state.response.length > 0}
            />
          )}
          {this.state.requesting && (
            <div className="text-center">
              <Spinner
                style={{ width: "3rem", height: "3rem" }}
                color="primary"
              />
            </div>
          )}
        </Container>
      </>
    );
  }
}
